/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC } from 'react'
import { PageTitle } from '../../_metronic/layout/core'
import AuthService from '../modules/auth/redux/AuthService'
import { AnaVezne } from './AnaVezne'
import { Tahsilat } from './Tahsilat/Tahsilat'


const MainPage: FC = () => {

  const user = AuthService.GetCurrentUser()
  const isAdmin = user.userData?.roles?.some((element: string) => element === "Anavezne Admin")

  return (<div>
    

    {/* begin::Row */}
    <div className='row gy-5 gx-xl-12'>
      <div className='col-xl-12'>
        {isAdmin ? <AnaVezne /> : <Tahsilat />}
        
      </div>
    </div>
    {/* end::Row */}

    
  </div>)
}


const MainPageWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Metro Tahsilat Listesi</PageTitle>
      <MainPage />
    </>
  )
}

export {MainPageWrapper}
